import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import { browserHistory }   from 'react-router';

let ArrowRight  = require('react-icons/lib/fa/caret-right');
let Quote = require('../Managers/Quote');

class SubmitInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSaveModal: false,
        };
    }

    saveForLater() {

    }

    backLinkHandler() {
        let productId = Quote.getByPath('BaseIndividualApplication.product.productId');
        let applicationType = Quote.getByPath('BaseIndividualApplication.applicationType');
        let referenceType = Quote.getByPath('BaseIndividualApplication.referenceType');
        let studentOnly = null;
        if (!window.uornorb(Quote.getByPath('BaseIndividualApplication.studentOnlyApplication'))) {
            studentOnly = Quote.getByPath('BaseIndividualApplication.studentOnlyApplication');
        }

        if (this.props.backLinkUrl) {
            window.location.replace(this.props.backLinkUrl);
            return true;
        }

        switch (this.props.currentNumber) {
            case 2: // Your details
                browserHistory.push('/application/declaration');
                break;
            case 3: // Your landlord
                browserHistory.push('/application/your-details');
                break;
            case 4: // Your finances
                if (productId === 11 || applicationType === 2) {
                    browserHistory.push('/application/your-details');
                } else {
                    browserHistory.push('/application/your-landlord');
                }
                break;
            case 5: // Additional details
                if (productId === 20 || (productId === 24 && referenceType === 1)) {
                    browserHistory.push('/application/your-details');
                } else if (studentOnly === true) {
                    browserHistory.push('/application/your-landlord');
                } else {
                    browserHistory.push('/application/your-finances');
                }
                break;
            case 6: // Summary
                browserHistory.push('/application/additional-details');
                break;
        }
    }

    render() {
        return (
            <question-row class="has-padding">
                <div className="form-navigation">
                    <div className="navigation-row">
                        {this.props.hasSecondaryButton ?
                            <div onClick={this.props.secondaryButtonAction.bind(this)} className="btn btn-default">
                                <span>{this.props.secondaryButtonText}</span>
                            </div>
                        : null}
                        {!this.props.disabled ?
                            <div onClick={this.props.callbackFunction.bind(this)} className="btn btn-success btn-split-content">
                                <span>{this.props.label}</span>
                                <ArrowRight />
                            </div>
                        :
                            <div className="btn btn-success btn-success-disabled btn-split-content">
                                <span>{this.props.label}</span>
                                <ArrowRight />
                            </div>
                        }
                    </div>
                    {this.props.backLink ?
                        <a onClick={this.backLinkHandler.bind(this)} className="underline">
                            {this.props.backLinkText ? this.props.backLinkText : <span>&lt; Back</span>}
                        </a>
                    : null}
                    {this.props.saveForLater ? <a onClick={this.props.saveForLaterFunc} href="#" className="underline pull-right">Save for later</a> : null}
                </div>
            </question-row>
        );
    }
}

SubmitInput.propTypes = {
    backLink:               PropTypes.bool,
    disabled:               PropTypes.bool,
    backLinkUrl:            PropTypes.string,
    backLinkText:           PropTypes.string,
    hasSecondaryButton:     PropTypes.bool,
    secondaryButtonText:    PropTypes.string,
    secondaryButtonAction:  PropTypes.func,
    callbackFunction:       PropTypes.func,
    label:                  PropTypes.string.isRequired,
    saveForLater:           PropTypes.bool,
    saveForLaterFunc:       PropTypes.func,
    currentNumber:          PropTypes.number,
};

SubmitInput.defaultProps = {
    currentNumber: 1,
    disabled: false,
};

export default SubmitInput;


// WEBPACK FOOTER //
// ./src/components/Fields/SubmitInput.js